import http from '../common/http';
import SubscriptionType from '../common/interfaces/Chargebee/SubscriptionType';
import ItemPriceType from '../common/interfaces/Chargebee/ItemPriceType';

export interface ChargebeeSubscriptionItemRequestAttr {
  item_price_id: string;
}

export interface PaymentUpdateSubscriptionAttr {
  subscriptionId?: string;
  subscriptionItemId: string;
}

class PaymentService {
  getSubscriptions(): Promise<SubscriptionType[]> {
    return http.get('/payment/subscriptions').then(response => response.data);
  }

  getPrices(): Promise<ItemPriceType[]> {
    return http.get('/payment/prices').then(response => response.data);
  }

  checkout(subscription_items: ChargebeeSubscriptionItemRequestAttr[]) {
    return http.post('/payment/checkout', { subscription_items }).then(response => response.data);
  }

  verifyPayment() {
    return http.get('/payment/checkout').then(response => response.data);
  }

  cancelSubscription(data: PaymentUpdateSubscriptionAttr) {
    return http.post('/payment/cancel', data).then(response => response.data);
  }

  subscribe(data: PaymentUpdateSubscriptionAttr) {
    return http.post('/payment/subscribe', data).then(response => response.data);
  }

  portal() {
    return http.post('/payment/portal').then(response => response.data);
  }
}

export default new PaymentService();
